import { gql } from "@apollo/client";
import client from "../../graphqlClient";
import leboncoinPossibleLocations from "../../leboncoinPossibleLocations";
import { calculatePriceFromCost } from "../../utils/priceCalculations";
import { CreateLeboncoinListingDocument, Media, MediaRole, MediaType, SyncLeboncoin_UpdateExternalListingMutation, SyncLeboncoin_UpdateExternalListingMutationVariables, SyncToLeboncoin_GetAdQuery, SyncToLeboncoin_GetAdQueryVariables, UpdateLeboncoinListingDocument } from "../../../codegen/graphql";
import { CREATE_LEBONCOIN_LISTING, DELETE_LEBONCOIN_LISTING, UPDATE_EXTERNAL_LISTING, UPDATE_LEBONCOIN_LISTING } from "../../graphql/leboncoinListing";
import { getDescriptionTemplate } from "../../components/AdListing/getLBCdescriptionTemplate";
import { checkLeboncoinListingVariationsConfigurationCompleteness, filterVariationsByConfiguration } from "../../../common/listingVariationsConfiguration";
import Big from "big.js";
import { calculatePriceWithCommissions } from "../../../common/pricesCalculation";
import { BetterError } from "../../../server/lib/BetterError";
import { selectBestSupplierProductVariation } from "../../../common/selectBestSuplierProductVariation";

export function classifyAdCategory(query: string): Promise<any> {
  return postMessageToLeboncoinExt(window, {
    action: 'classify-ad-category',
    query
  });
}

export async function getAdFormConfig(categoryId: string): Promise<any> {
  if (sessionStorage.getItem('leboncoin_ad_form_config_'+categoryId)) {
    return JSON.parse(sessionStorage.getItem('leboncoin_ad_form_config_'+categoryId)!);
  }

  const config = await postMessageToLeboncoinExt(window, {
    action: 'get-ad-form-config',
    categoryId
  });

  sessionStorage.setItem('leboncoin_ad_form_config_'+categoryId, JSON.stringify(config));

  return config;
}

export function extractAdFormConfig(config: any) {
  const leboncoin_adParamsItems = config.navigation.ordered_steps.find((step: any) => (
    step.identifier === 'STEP_IDENTIFIER_ADPARAMS'
  ))!.ordered_items;

  const formConfig: {
    itemsDefinition: any;
    handlesVariations: boolean;
    formItems: any[];
    formItemsKeys: string[];
    variationsItemsKeys: string[];
    variationsItems: any[];
  } = {
    itemsDefinition: config.definitions.items,

    formItems: leboncoin_adParamsItems.map((identifier: any) => (
      config.definitions.items.find((itemDefinition: any) => (
        itemDefinition.identifier === identifier
      ))
    )),
    formItemsKeys: [],

    handlesVariations: false,
    variationsItemsKeys: [],
    variationsItems: [],
  };

  const leboncoin_variationsStep = config.navigation.ordered_steps.find((step: any) => (
    step.identifier === 'STEP_IDENTIFIER_VARIATION'
  ));

  if (leboncoin_variationsStep) {
    formConfig.handlesVariations = true;

    const leboncoin_variationsDefinition = config.definitions.items.find((item: any) => (
      leboncoin_variationsStep.ordered_items.includes(item.identifier)
    ));

    const leboncoin_variationsPrimaryKeys = leboncoin_variationsDefinition.entities.primary_associated_keys;

    // console.log({
    //   leboncoin_variationsStep,
    //   leboncoin_variationsDefinition,
    //   leboncoin_variationsPrimaryKeys,
    // })
    formConfig.variationsItems = formConfig.formItems.filter((definition: any) => (
      leboncoin_variationsPrimaryKeys.indexOf(definition.answer_modelization.representation.associated_key) !== -1
    ));

    formConfig.formItems = formConfig.formItems.filter((definition: any) => (
      leboncoin_variationsPrimaryKeys.indexOf(definition.answer_modelization.representation.associated_key) === -1
    ));

  }

  formConfig.formItemsKeys = formConfig.formItems.map((definition: any) => (
    definition.identifier
  ));

  formConfig.variationsItemsKeys = formConfig.variationsItems.map((definition: any) => (
    definition.identifier
  ));

  return formConfig;
}

export function getAdData({
  leboncoinUrl,
  leboncoinAdId,
}: {
  leboncoinUrl?: string,
  leboncoinAdId?: string,
}): Promise<any> {
  return postMessageToLeboncoinExt(window, {
    action: 'get-ad-data',
    leboncoinUrl,
    leboncoinAdId,
  });
}


// const PostToOtherCitiesQuery = gql`
// query PostToOtherCities($ids: [ID!]!) {
//   ads(ids: $ids) {
//     id
//     leboncoinListings {
//       id
//       data
//     }
//   }
// }
// `;

// export async function postToOtherCities(
//   listingIds: string[]
// ) {
//   const { data } = await client.query({
//     query: PostToOtherCitiesQuery,
//     variables: { ids: listingIds }
//   });

//   for (const ad of data.ads) {
//     const adData = ad.leboncoinListings[0]?.data;
//     if (!adData) {
//       console.log(`${ad.id}: No data found for ad`);
//       continue;
//     }

//     const possibleLocations = Object.values(leboncoinPossibleLocations);
//     for (const location of possibleLocations) {
//       const listing = ad.leboncoinListings.find((listing: any) => (
//         listing.data.location.city.toLowerCase() === location.city.toLowerCase()
//       ));

//       if (!listing) {
//         const newId = await postMessageToLeboncoinExt(window, {
//           action: 'duplicate-to-city',
//           adData,
//           city: location.city.toLowerCase(),
//         });

//         await client.mutate({
//           mutation: UpsertLeboncoinListingMutation,
//           variables: {
//             input: {
//               leboncoinId: `${newId}`,
//               data: null,
//               adId: ad.id,
//             },
//           },
//         });
//         await new Promise(resolve => setTimeout(resolve, (Math.random() * 1000) + 1000));
//       } else {
//         console.log(`${ad.id}: Listing already posted to ${location.city}`);
//       }
//     }
//   }
// }




export function postToOtherCities() {}

// new ad : post https://api.leboncoin.fr/api/adsubmit/v2/classifieds?with_variation=true

// update ad : put https://api.leboncoin.fr/api/adsubmit/v2/classifieds/2944285482?with_variation=true


export async function uploadMedias(medias: Pick<Media, 'id' | 'url'>[]): Promise<{
  [mediaId: string]: {
    name: string;
    url: string;
  };
}> {
  const allImagesFiles = await Promise.all(medias.map((image) => (
    fetch(image.url)
      .then(response => response.blob())
      .then(blob => new File([blob], image.url.split('/').pop()!))
  )));

  const imagesUploaded = await postMessageToLeboncoinExt(window, {
    action: 'upload-images',
    images: allImagesFiles,
  });

  const imagesMapById = imagesUploaded.reduce((acc: any, image: any, index: number) => {
    const media = medias[index];
    acc[media.id] = {
      name: image.url.split('/').pop()!,
      url: image.url,
    };
    return acc;
  }, {});

  return imagesMapById;
}


/*
 * Send message to extension
 */
export function postMessageToLeboncoinExt(targetWindow: Window, message: any, origin: string = '/'): Promise<any> {
  return new Promise((resolve, reject) => {
    const messageId = `msg_${Math.random().toString(36).substr(2, 9)}`;
    const timeout = 30000; // Timeout after 8 seconds

    function handleMessage(event: MessageEvent) {
      if (event.data
        && event.data.messageId === messageId
        && event.data.source === 'manage-ads-ext-content-script'
      ) {
        window.removeEventListener('message', handleMessage);
        clearTimeout(timer);

        console.log('Received response', event.data)
        if (event.data.data) {
          resolve(event.data.data);
        } else if (event.data.error) {
          reject(event.data.error);
        } else {
          resolve(event.data);
        }
      }
    }

    const timer = setTimeout(() => {
      window.removeEventListener('message', handleMessage);
      reject(new Error('Response timed out'));
    }, timeout);

    window.addEventListener('message', handleMessage);

    targetWindow.postMessage({
      source: 'manage-ads-ext-web-page',
      data: message,
      messageId
    }, origin);
  });
}
